module.exports = __webpack_public_path__ + "static/media/intellipay-dark.8d4ff8dc.png";